'use client';

import { Badge } from '@ravago/shared/radiance/components/badge/components/Badge/Badge';
import { useTranslations } from '@ravago/shared/translations/client';

interface Props {
   isMtsLocal: boolean;
}

export const LeadTimeBadge = ({ isMtsLocal }: Props) => {
   const translate = useTranslations();

   return (
      <Badge leadingIcon="truck" variant={isMtsLocal ? 'info' : 'neutral'}>
         {isMtsLocal
            ? translate('request-for-quotation.lead-time.mts-local-days')
            : translate('request-for-quotation.lead-time.delivery-on-request')}
      </Badge>
   );
};
